// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__2Umx5","footer":"ModalError_footer__2b2-B"};